module.exports = "https://static.wagwalking.com/_next/static/images/sara-ochoa-47032e1ba6b3439467e1c019197f40f7.png";